import React, { useContext, useState } from "react";
import { MenuIcon, NotificationIcon } from "../icons";
import { SidebarContext } from "../context/SidebarContext";
import userIcon from "../assets/img/userIcon.png";
import { WalletIcon } from "../icons/index.js";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { useTranslation } from "react-i18next";
import { useQuery, useInfiniteQuery } from "react-query";
import { getBalance } from "../lib/wallet-service.js";
import { getNotifications, getUnreadCount } from "../lib/notification-apis";
import NotificationDropdown from "./Dropdowns/NotificationDropdown.js";
import ComvivaLogo from "../assets/img/comviva-logo.svg";
import { useTheme } from "../context/ThemeContext.js";
import axios from "axios";
import getIP from "../getIP.js";
import HeaderWallet from "./Popover/HeaderWallet";
import HeaderAccount from "./Popover/HeaderAccount";

const IP = getIP();

const Header = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { theme, setTheme } = useTheme();
  const [showAccountDropDown, setAccountShowDropDown] = useState(false);
  const [showCreditsDropDown, setShowCreditsDropDown] = useState(false);
  const [showAlertDropDown, setShowAlertDropDown] = useState(false);
  const [openInfoModal, setOpenInfoModal] = useState(true);
  const [openInfoModalForWallet, setOpenInfoModalForWallet] = useState(false);

  const { toggleSidebar } = useContext(SidebarContext);
  const {
    logout,
    userData,
    userDetails,
    userScope,
    loggedInRole,
    globalConfig,
    setUserDetails,
    currencySymbol,
  } = useContext(AuthContext);

  const enableWallet =
    globalConfig?.find((e) => e.key === "enableWallet")?.value || "true";

  const { data, status, isLoading } = useQuery(
    ["getBalance", userDetails, userDetails?.sub],
    getBalance,
    {
      enabled: loggedInRole !== "PA",
      refetchInterval: 4000,
      onSuccess: (data) => {
        if (!userDetails?.hasOwnProperty("billingType")) {
          setUserDetails({ ...userDetails, ...data?.data });
        }
      },
    }
  );

  const url = `${IP}/api/v1/accounts/users?pgsize=10&pgindex=1`;
  const fetchgroupID = async ({ queryKey }) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${queryKey[1]}`,
        },
      };
      const res = await axios.get(url, config);
      return res.data;
    } catch (error) {
      console.log("err", error);
      throw error;
    }
  };

  const { data: groupid } = useQuery(
    ["getAccountListingData", userDetails?.token],
    fetchgroupID
  );

  const groupID = groupid?.data[0]?.groupId;

  const {
    data: notificationsData,
    isLoading: isNotificationLoading,
    refetch: notificationRefetch,
  } = useInfiniteQuery(
    ["getNotifications", userDetails, userDetails?.sub],
    getNotifications,
    { enabled: userScope?.alerts?.read }
  );

  const { data: unreadCount, refetch: unreadCountRefetch } = useQuery(
    ["getUnreadcount", userDetails, userDetails?.sub],
    getUnreadCount
  );

  let style = {
    accountDropDown: `absolute ${showAccountDropDown ? "flex" : "hidden"}
    top-6 bg-white ltr:right-6 rtl:left-6 bg-white flex flex-col mt-[0.65rem] rounded-xl text-sm shadow-md p-5 place-content-center`,
    creditsDropDown: `absolute ${showCreditsDropDown ? "flex" : "hidden"}
    top-[25px] bg-white flex flex-col mt-[1.1rem] px-3 box-border text-xs shadow-md ltr:left-0 rtl:right-1 place-content-center rounded-lg`,
  };

  const renderWalletPage = () => {
    navigate("/app/header/wallets");
    setShowCreditsDropDown(!showCreditsDropDown);
  };

  const renderTransferCreditsPage = () => {
    navigate("/app/header/transfercredits");
    setShowCreditsDropDown(!showCreditsDropDown);
  };

  const hexToRgb = (hex) => {
    hex = hex.replace(/^#/, "");

    let bigint = parseInt(hex, 16);
    let r = (bigint >> 16) & 255;
    let g = (bigint >> 8) & 255;
    let b = bigint & 255;

    return `${r}, ${g}, ${b}`;
  };
  const closeInfoModalFn = () => {
    setOpenInfoModalForWallet(false);
  };
  const openInfoModalFn = () => {
    setOpenInfoModalForWallet(true);
  };
  return (
    <div
      className="z-10 flex border-[1px] justify-between border-solid border-[#D2D2D2] flex-grow sticky bg-white top-0 w-full"
      style={{ height: 64 }}
    >
      <div className="flex items-center w-[151px]">
        <div className="w-[30px] h-[85px] lg:hidden ltr:ml-4 rtl:mr-4">
          <MenuIcon
            onClick={toggleSidebar}
            height={85}
            width={35}
            className="cursor-pointer"
          />
        </div>
      </div>
      {theme.announcementFlag === "Enable" &&
        (theme.announcementText !== "" || !theme.announcementText) && (
          <div
            style={{ color: "#800000" }}
            className="flex h-8 md:ltr:ml-20 flex-wrap break-all md:rtl:mr-20 items-center self-center place-items-center rounded gap-2"
            rel="noreferrer"
          >
            <div className="flex flex-row gap-2">
              {theme.announcementText}
              {theme.display && theme.url && (
                <a
                  href={theme.url}
                  target="_blank"
                  className="text-blue-400 ml-2"
                  rel="noopener noreferrer"
                >
                  {theme.display}
                </a>
              )}
              <button
                type="button"
                onClick={() => {
                  setTheme({ ...theme, announcementFlag: "Disable" });
                }}
                className="font-bold text-sm"
              >
                x
              </button>
            </div>
          </div>
        )}
      <div className="self-center">
        <div className="flex items-center  justify-end">
          {(loggedInRole === "EA" || loggedInRole === "EU") && (
            <HeaderWallet
              balance={data?.data?.balance}
              status={status}
              isLoading={isLoading}
              theme={theme}
            />
          )}
          {/* {loggedInRole === "EA" || loggedInRole === "EU" ? (
            <div
              onClick={() => setShowCreditsDropDown(!showCreditsDropDown)}
              // onClick={() => setShowCreditsDropDown(true)}
              // onMouseLeave={() => setShowCreditsDropDown(false)}
              className="relative  py-1 rounded-[8px] bg-opacity-[0.06] flex items-center cursor-pointer"
              style={{
                backgroundColor: `rgba(${hexToRgb(theme.secondaryColor)}, 0.1)`,
                // boxShadow: `rgba(${hexToRgb(
                //   theme.secondaryColor
                // )}, 1) 0px 0px 3px inset`,
              }}
            >
              <div className="ltr:ml-3 rtl:mr-3 py-1">
                <WalletIcon
                  className="w-6 h-5"
                  style={{ color: theme.secondaryColor }}
                />
              </div>

              <div
                onClick={() => {
                  setShowCreditsDropDown(!showCreditsDropDown);
                  closeInfoModalFn();
                }}
                onMouseEnter={openInfoModalFn}
                onMouseLeave={closeInfoModalFn}
                className="flex relative   flex-col ml-2 text mx-4"
              >
                <h1
                  style={{ color: theme.secondaryColor, opacity: "75%" }}
                  className=" text-xs ltr:pr-2 rtl:pl-2"
                >
                  {t("_Balance")}
                </h1>
                {status === "success" && !isLoading && (
                  <h1
                    style={{ color: theme.secondaryColor }}
                    className=" font-bold opacity-100 text-sm"
                  >
                    {currencySymbol} {scaleNumber(data?.data?.balance)}
                  </h1>
                )}
                {openInfoModalForWallet &&
                  status === "success" &&
                  !isLoading && (
                    <div className="absolute ltr:-left-1/2 rtl:-right-10 -bottom-11 ">
                      <InfoModal
                        closeInfoModal={closeInfoModalFn}
                        for="balance"
                      >
                        <span>
                          <span className="text-xs">
                            {currencySymbol}{" "}
                            {Number(
                              Math.abs(data?.data?.balance)
                            ).toLocaleString("en", {
                              minimumFractionDigits: 2,
                            })}
                          </span>
                        </span>
                      </InfoModal>
                    </div>
                  )}
              </div>

              <div style={{ width: 150 }} className={style.creditsDropDown}>
                {enableWallet === "true" && (
                  <h1
                    className="mx-3 mt-3 mb-2 cursor-pointer font-semibold"
                    onClick={() => renderWalletPage()}
                  >
                    {t("_My_wallet")}
                  </h1>
                )}
                <h1
                  className={`m-3 cursor-pointer font-semibold ${
                    !userScope?.wallets?.transfer &&
                    `opacity-50 cursor-not-allowed`
                  }`}
                  onClick={() => {
                    if (userScope?.wallets?.transfer)
                      renderTransferCreditsPage();
                  }}
                >
                  {t("_Transfer_Credits")}
                </h1>
              </div>
            </div>
          ) : null} */}
          <div
            className={`inline-flex relative h-[23px] w-[23px] sm:mx-[35px] mx-2 mt-1 ${
              userScope?.alerts?.read
                ? "cursor-pointer"
                : "cursor-not-allowed opacity-50"
            } `}
            onClick={() => {
              if (userScope?.alerts?.read) {
                setShowAlertDropDown(!showAlertDropDown);
              }
            }}
            onMouseLeave={() => {
              if (userScope?.alerts?.read) {
                setShowAlertDropDown(false);
              }
            }}
          >
            {!isNotificationLoading &&
              unreadCount?.data?.count > 0 &&
              userScope?.alerts?.read && (
                <span
                  style={{ backgroundColor: theme.primaryColor }}
                  className={`absolute -right-1 -top-2 select-none leading-4 rounded-full w-4 h-4 p-0 m-0 text-white font-mono text-center ${
                    unreadCount?.data?.count < 100 ? " text-xvs " : "text-xxs "
                  }`}
                >
                  {unreadCount?.data?.count < 100
                    ? unreadCount?.data?.count
                    : "99+"}
                </span>
              )}
            <NotificationIcon />
            {showAlertDropDown === true ? (
              <NotificationDropdown
                navigate={navigate}
                notificationRefetch={notificationRefetch}
                unreadRefetch={unreadCountRefetch}
                data={notificationsData?.pages[0]?.response?.data?.data}
              />
            ) : null}
          </div>
          <HeaderAccount groupID={groupID} loggedInRole={loggedInRole} />
          {/* <div
            className="flex cursor-pointer relative "
            onMouseLeave={() => setAccountShowDropDown(false)}
            onClick={() => setAccountShowDropDown(!showAccountDropDown)}
          >
            <img
              src={userData?.profileImg || userIcon}
              className="rounded-full h-9  w-10 object-cover ltr:mr-[8px] rtl:ml-[8px]"
              alt="user-icon"
            />
            <h1
              className="font-nunito my-auto ltr:mr-[31px] rtl:ml-[31px] hidden sm:inline-block font-bold"
              onMouseEnter={() => {
                setOpenInfoModal(true);
              }}
              onMouseLeave={() => {
                setOpenInfoModal(false);
              }}
            >
              {userData.name?.length > 12
                ? userData.name.substring(0, 12) + "..."
                : userData.name}
              {userData.name?.length > 12 && openInfoModal && (
                <InfoModal
                  closeInfoModal={() => {
                    setOpenInfoModal(false);
                  }}
                  for="user"
                >
                  <span className="text-xs">{userData.name}</span>
                </InfoModal>
              )}
            </h1>
            <div style={{ width: 200 }} className={style.accountDropDown}>
              <h1
                className="m-3 cursor-pointer font-semibold text-sm"
                onClick={() => {
                  navigate("/app/header/change-profile");
                }}
              >
                {t("_My_Profile")}
              </h1>
              {loggedInRole !== "PA" && (
                <h1
                  className="m-3 cursor-pointer font-semibold text-sm"
                  onClick={() => {
                    navigate(`/app/header/billing`);
                  }}
                >
                  {t("_Billing")}
                </h1>
              )}
              {loggedInRole == "EA" || loggedInRole == "EU" ? null : (
                <h1
                  className="m-3 cursor-pointer font-semibold text-sm"
                  onClick={() => {
                    navigate(`/app/header/settings/${groupID}`);
                  }}
                >
                  {t("_Settings")}
                </h1>
              )}
              <h1
                className="m-3 cursor-pointer font-semibold text-sm"
                onClick={() => {
                  logout();
                }}
              >
                {t("_Log_out")}
              </h1>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

const InfoModal = (props) => {
  const styles = {
    modalStyleForUser: `bg-[#3C3C3C] absolute flex z-10 justify-center shadow-[0_3px_8px_rgba(0,0,0,0.24)] rounded-md right-5 top-9 px-2 pb-1 rounded-xl w-max text-white flex`,
    modalStyleForBalance: `bg-[#4E4E4E]  flex z-10 justify-center shadow-[0_3px_8px_rgba(0,0,0,0.24)] rounded-md  px-2 pb-1  w-max text-[#FFFFFF] flex`,
  };

  return (
    <div
      className={
        props.for === "user" ? styles.modalSty : styles.modalStyleForBalance
      }
      style={{
        boxShadow: `0px 3px 6px #0000001A`,
      }}
    >
      {props.children}
    </div>
  );
};

export default Header;
